import { useContext, useMemo } from 'react';
import { SignInContext, USER_GROUPS } from '../../users';
import { ESubmissionItemStatus, TSubmission, TSubmissionItem, TSubmissionItemInfo } from '../types/submissions.types';

export const useHasFullPermissions = (submissionInfo?: TSubmission | TSubmissionItemInfo) => {
  const { user } = useContext(SignInContext);
  return useMemo(
    () =>
      Boolean(user.groups.includes(USER_GROUPS.ADMIN) || (submissionInfo && submissionInfo.leads.includes(user._id))),
    [user.groups, submissionInfo?.leads]
  );
};

export const useHasAssigneePermissions = (hasFullPermissions: boolean, submissionItem?: TSubmissionItem) => {
  const { user } = useContext(SignInContext);
  return useMemo(() => {
    const isAssignee = user._id === submissionItem?.assignee;
    return hasFullPermissions || (isAssignee && submissionItem?.status !== ESubmissionItemStatus.ACCEPTED);
  }, [hasFullPermissions, submissionItem]);
};
